export default [{
    name: 'dashboard',
    children: [{
        path: '/admin/notifyinfo/list',
        name: 'NotifyInfoList',
        components: {

            default: resolve => require(['./notifyinfo/list.vue'], resolve)
        }
    }, {
        path: '/admin/notifyinfo/update',
        name: 'NotifyInfoUpdate',
        components: {

            default: resolve => require(['./notifyinfo/update.vue'], resolve)
        }
    }, {
        path: '/admin/feedBack/list',
        name: 'FeedBackList',
        components: {

            default: resolve => require(['./feedBack/list.vue'], resolve)
        }
    }, {
        path: '/admin/feedBack/detail',
        name: 'FeedBackDetail',
        components: {

            default: resolve => require(['./feedBack/detail.vue'], resolve)
        }
    },
    {
        path: '/admin/settinginfo/list',
        components: {
            default: resolve => require(['./settinginfo/list.vue'], resolve)
        }
    },
    {
        path: '/admin/settinginfo/details',
        name:'settingupdate',
        components: {
            default: resolve => require(['./settinginfo/update.vue'], resolve)
        }
    }
]
}]



// WEBPACK FOOTER //
// ./src/views/admin/router.js